export const ANY_EMPLOYEE_MOCK = {
  uuid: '-1',
  selected: true,
  firstName: 'Any free employee',
  lastName: '',
  colorInCalendar: '#ffffff',
  nearestAvailableTime: '',
  image: null,
};
